import {
    ref, onMounted, onBeforeUnmount,
    unref,
} from 'vue';

export const useTouch = (elMaybeRef = window, options = {}) => {
    const {
        prevent = false,
    } = options;
    const xDelta = ref(0);
    const yDelta = ref(0);

    const isDown = ref(false);

    const startCoords = {
        x: 0,
        y: 0,
    };

    const calcMousePos = (e) => {
        if (!isDown.value) return;

        const { clientX, clientY, } = e.touches[0];
        xDelta.value = clientX - startCoords.x;
        yDelta.value = clientY - startCoords.y;
    };

    const onDown = (e) => {
        if (e.cancelable && prevent) e.preventDefault();

        isDown.value = true;
        const { clientX, clientY, } = e.touches[0];
        startCoords.x = clientX;
        startCoords.y = clientY;
        xDelta.value = 0;
        yDelta.value = 0;
    };

    const onUp = () => {
        isDown.value = false;
    };

    onMounted(() => {
        const el = unref(elMaybeRef);
        if (!el) return;

        el.addEventListener('touchstart', onDown, { passive: !prevent });
        el.addEventListener('touchend', onUp, { passive: !prevent });
        el.addEventListener('touchcancel', onUp, { passive: !prevent });
        el.addEventListener('touchmove', calcMousePos, { passive: !prevent });
    });

    onBeforeUnmount(() => {
        const el = unref(elMaybeRef);
        if (!el) return;

        el.removeEventListener('touchstart', onDown, { passive: !prevent });
        el.removeEventListener('touchend', onUp, { passive: !prevent });
        el.removeEventListener('touchcancel', onUp, { passive: !prevent });
        el.removeEventListener('touchmove', calcMousePos, { passive: !prevent });
    });

    return {
        xDelta,
        yDelta,
        isDown,
    };
};
